export default "__VITE_ASSET__BTGONFfR__"